import { setConfigBgColorClass } from '../../../utils/layout-util'

export function articleInnerConstrainedClasses(layoutConfigs: { columnSize?: string } = {}) {
  if (layoutConfigs.columnSize) {
    if (layoutConfigs.columnSize == 'customConstrainedRight') {
      return 'u-sizeConstrainedRight u-md-marginRight0 u-sm-marginRight0'
    } else if (layoutConfigs.columnSize == 'customConstrainedLeft') {
      return 'u-sizeConstrainedLeft'
    } else {
      return 'u-sizeConstrained'
    }
  } else {
    return 'u-sizeConstrained'
  }
}

export function articleInnerVertPadding(
  layoutConfigs: { columnSize?: string; globalBgColor?: { color?: string } } = {}
) {
  if (setConfigBgColorClass(layoutConfigs)) {
    if (layoutConfigs.columnSize) {
      if (
        layoutConfigs.columnSize == 'customConstrainedRight' ||
        layoutConfigs.columnSize == 'customConstrainedLeft'
      ) {
        return 'u-paddingVert0gu'
      } else {
        return 'u-paddingVert10gu'
      }
    } else {
      if (layoutConfigs?.globalBgColor?.color !== 'white') {
        return 'u-paddingVert10gu'
      }
      return ''
    }
  } else {
    return ''
  }
}

export function setArticleIntroLayoutSize(layoutConfigs: { columnSize?: string } = {}) {
  let size
  if (layoutConfigs.columnSize) {
    size = 'u-size' + layoutConfigs.columnSize + ' u-sm-sizeFull u-marginCenter'
  } else {
    size = 'u-size10of12 u-lg-before1of12 u-md-before1of12 u-sm-sizeFull'
  }
  return size
}

export function setArticleLayoutSize(layoutConfigs: { columnSize?: string } = {}) {
  let size
  if (layoutConfigs.columnSize) {
    size = 'u-size' + layoutConfigs.columnSize + ' u-sm-sizeFull u-marginCenter'
  } else {
    size = 'u-size10of12 u-lg-before1of12 u-md-before1of12 u-sm-sizeFull'
  }
  return size
}
